const enemySumByWave: {
  [key: number]: {
    basic: number;
    fast: number;
    tank: number;
    ranged: number;
    boss: number;
  };
} = {};

export const calculateSumForWave = (wave: number) => {
  if (enemySumByWave[wave]) return enemySumByWave[wave];
  const totals = {
    basic: Math.floor(18.6 * wave ** 1.14),
    fast: Math.floor(0.502 * wave ** 1.43),
    tank: Math.floor(0.29 * wave ** 1.51),
    ranged: Math.floor(0.0275 * wave ** 1.78),
    boss: Math.floor(wave / 10),
  };
  enemySumByWave[wave] = totals;
  return totals;
};

export const getEnemyCountsForWave = (wave: number) => {
  if (wave <= 1) {
    return calculateSumForWave(1);
  }
  const previous = calculateSumForWave(wave - 1);
  const totals = calculateSumForWave(wave);
  return {
    basic: totals.basic - previous.basic,
    fast: totals.fast - previous.fast,
    tank: totals.tank - previous.tank,
    ranged: totals.ranged - previous.ranged,
    boss: totals.boss - previous.boss,
  };
};

export const getEnemyCountsForRange = (start: number, end: number) => {
  const startSum = calculateSumForWave(start);
  const endSum = calculateSumForWave(end);
  return {
    basic: endSum.basic - startSum.basic,
    fast: endSum.fast - startSum.fast,
    tank: endSum.tank - startSum.tank,
    ranged: endSum.ranged - startSum.ranged,
    boss: endSum.boss - startSum.boss,
  };
};
